import { ratingKeys } from "keys/rating";
import { getAccuracyStatsFetch, getCorrectWordsPerMinuteStatsFetch, getFactoredAccuracyStatsFetch, getFluencyStatsFetch, getMinorErrorStatsFetch, getReadingFluencyStatsFetch, getSelfCorrectionStatsFetch } from "store/middlewares/rating.crud";
import { queryClient as qc } from 'keys'

export const checkTypes = [
    { id: "words_per_minute", name: ratingKeys.words_per_minute, barItemWidth: 5.5, queryFn: getFluencyStatsFetch, queryKey: qc.fluencyStats },
    { id: "correct_words_per_minute", name: ratingKeys.correct_words_per_minute, barItemWidth: 5.5, queryFn: getCorrectWordsPerMinuteStatsFetch, queryKey: qc.correctWordsPerMinute },
    { id: "percent_accuracy", name: ratingKeys.percent_accuracy, percent: true, barItemWidth: 20, queryFn: getAccuracyStatsFetch, queryKey: qc.accuracyStats },
    { id: "factored_percent_accuracy", name: ratingKeys.factored_percent_accuracy, percent: true, barItemWidth: 20, queryFn: getFactoredAccuracyStatsFetch, queryKey: qc.factoredAccuracyStats },
    { id: "fluency", name: ratingKeys.fluency_reading, percent: true, barItemWidth: 50, queryFn: getReadingFluencyStatsFetch, queryKey: qc.readingFluencyStats },
    { id: "non_self_corrected", name: ratingKeys.self_correction, percent: true, barItemWidth: 20, queryFn: getSelfCorrectionStatsFetch, queryKey: qc.readingFluencyStats },
    { id: "non_minor_error", name: ratingKeys.minor_error, percent: true, barItemWidth: 20, queryFn: getMinorErrorStatsFetch, queryKey: qc.minorErrorStats },
]

export const checkType = {
    words_per_minute: "words_per_minute",
    words_correct_per_minute: "words_correct_per_minute",
    percent_accuracy: "percent_accuracy",
    factored_percent_accuracy: "factored_percent_accuracy",
    fluency_reading: "fluency_reading"
}


export const checkTypes2 = [
    { id: "fluency", name: ratingKeys.words_per_minute },
    { id: "words_correct_per_minute", name: ratingKeys.correct_words_per_minute },
    { id: "percent_accuracy", name: ratingKeys.percent_accuracy },
    { id: "factored_percent_accuracy", name: ratingKeys.factored_percent_accuracy },
    { id: "fluency_reading", name: ratingKeys.fluency_reading },
]